import { BCMSRecord, DisabledPrompt, Link, useBCMSContext, useRoute, useWorkflowStep } from "@bcm-dev/bcms-vite";
import CardFreeCashWrapper from "components/shared/containers/CardFreeCashWrapper";
import MainContentContainer, { MainContentHeader } from "components/shared/containers/MainContentContainer";
import { UIPrimaryButton } from "components/ui/UIButton";
import { getDefault, getWorkflowSteps } from "components/workflows/CardFreeCashWorkflow";
import { Card } from "model";
import React from "react";
import { SVGAsset } from "res";
import "./styles.css";

/**
 * @function AccessCodePage
 * @param {String} amount - Allows us to set the amount 
 * @return {React.Component}
 * @exported true
 * @description The main component for AccessCodePage
 */

export default function AccessCodePage(props) {
  const globalController = useBCMSContext();
  const navigate = useRoute();
  BCMSRecord.globalControllerFor([ Card ], globalController);
  const workflowStep = useWorkflowStep(getDefault, getWorkflowSteps);

const amount = workflowStep.getStepState.cashAmount


const submit = evt => {
  navigate("/home/recenttransactions/"+workflowStep.getStepState.card.id)
}

  return(
    <CardFreeCashWrapper className="access-code-page">
      <MainContentContainer className="text-center" header={<MainContentHeader text="Access Code" />}>
        
        
        {/* Access Code Container */}
        <div className="access-code-container text-center">
          <div className="access-code-upper-content">
            <b>1234 567 8901</b>
            <p className="sub-text">Expires in 30 min 18 seconds</p>
          </div>
          <p className="for-amount-text">For amount {amount}</p>
        </div>

        <p className="text-center">Use this code with your debit card PIN at Popmoney ATM.</p>

        <div className="links-container flex-container flex-horizontal align-center-container column-space-between-container">
          <DisabledPrompt>
            <Link>
              <span>I need a new code</span>
            </Link>
          </DisabledPrompt>
          <DisabledPrompt>
            <Link>
              <span>Find an ATM</span>
            </Link>
          </DisabledPrompt>
        </div>

        <div className="information-container flex-container flex-horizontal align-center-container">
          <SVGAsset id="InformationIcon" className=" set-width left-icon-container" />
          <p className="sub-text text-left">Using CardFree Cash will override all existing card controls. If your card is locked you can still use CardFree Cash.</p>
        </div>

        <UIPrimaryButton text="Done" onClick={submit}/>
      </MainContentContainer>
    </CardFreeCashWrapper>
  );
}